// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// C:/Users/pc 01/Documents/vuesax/node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!C:/Users/pc 01/Documents/vuesax/node_modules/vue-style-loader!C:/Users/pc 01/Documents/vuesax/node_modules/css-loader?{"sourceMap":true}!C:/Users/pc 01/Documents/vuesax/node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5e1f64b7","scoped":false,"hasInlineConfig":false}!C:/Users/pc 01/Documents/vuesax/node_modules/vue-loader/lib/selector.js?type=styles&index=0!./components/vsButton.vue
// module id = ESC+
// module chunks = 0